export default "__VITE_ASSET__lflwAFhz__"